import * as React from 'react'
import { BaseIconProps } from '../../types'

function SvgCamera({ size = '24', color = '#666', ...props }: BaseIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.465 3a2 2 0 011.664.89l1.11 1.665A1 1 0 0018.07 6H19a3 3 0 013 3v9a3 3 0 01-3 3H5a3 3 0 01-3-3V9a3 3 0 013-3h.93a1 1 0 00.832-.445l1.11-1.664A2 2 0 019.534 3h4.93zm0 2h-4.93l-1.11 1.664A3 3 0 015.93 8H5a1 1 0 00-1 1v9a1 1 0 001 1h14a1 1 0 001-1V9a1 1 0 00-1-1h-.93a3 3 0 01-2.496-1.336L14.464 5zM12 9a4 4 0 110 8 4 4 0 010-8zm0 2a2 2 0 100 4 2 2 0 000-4z"
        fill={color}
      />
    </svg>
  )
}

export default SvgCamera
